import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";

//Style
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";

//Home
import Index from "views/Index.js";

//Pagine
import RiceverePaginaHtml from "views/pagine/riceverePaginaHtml.js";
import Dispatcher from "views/pagine/dispatcher.js";
import CommonJS from "views/pagine/commonJS.js";
import EsModule from "views/pagine/esModule.js";
import AsyncAwait from "views/pagine/asyncAwait.js";
import Express from "views/pagine/express.js";
import TemplateEngine from "views/pagine/templateEngine.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/index" element={<Index />} />
      <Route path="/RiceverePaginaHtml" element={<RiceverePaginaHtml />} />
      <Route path="/Dispatcher" element={<Dispatcher />} />
      <Route path="/CommonJS" element={<CommonJS />} />
      <Route path="/EsModule" element={<EsModule />} />
      <Route path="/AsyncAwait" element={<AsyncAwait />} />
      <Route path="/Express" element={<Express />} />
      <Route path="/TemplateEngine" element={<TemplateEngine />} />
      <Route path="*" element={<Navigate to="/index" replace />} />
    </Routes>
  </BrowserRouter>
);
